export default __webpack_public_path__ + "static/media/td.16a25e21.svg";